import { Image, SegmentedCard, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const TabWrapper = styled.div`
  display: flex;

  ${SegmentedCard.S.SegmentedCardItemHeader} {
    align-items: flex-start;
    margin-top: 8px;
  }

  ${SegmentedCard.S.SegmentedCardItemHeaderBody} {
    align-items: flex-start;
  }
`;

const ContactListContentWrapper = styled.div`
  margin-top: 40px;
`;

const EmptyContent = styled.div`
  border: 1px dashed var(--color-border-default);
  margin-bottom: 24px;
  padding: 40px;
  text-align: center;
`;

const ActionFooter = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 24px;
`;

const ContactIndividualContentWrapper = styled.div`
  background-color: var(--color-bg-weaker);
  display: flex;
  flex-direction: row;
  gap: 24px;
  margin-top: 40px;
  padding: 24px;
  width: 100%;
`;

const QuantityContainer = styled.div`
  display: flex;
  flex: 0.6;
  flex-direction: column;
  position: relative;
`;

const RecipientQuantityInputArea = styled.div``;

const MaxContactError = styled.div`
  color: var(--color-error-strong);
  margin-top: 10px;
`;

const ImageContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 0.4;
  flex-direction: column;
  gap: 8px;
  text-align: center;
`;

const ContactImage = styled(Image)`
  margin-top: 40px;
  max-width: 280px;
  width: 100%;
`;

const ShareLinks = styled.div`
  column-gap: 40px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-top: 40px;
  row-gap: 16px;
`;

const ShareLink = styled.div``;

const TabDescriptionText = styled(Typography)`
  align-items: center;
  background: var(--color-accent-secondary-weakest);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  color: var(--color-neutral-500);
  display: flex;
  gap: 3px;
  padding: 3px;
  width: 100%;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
`;

export {
  ActionButtons,
  ActionFooter,
  ContactImage,
  ContactIndividualContentWrapper,
  ContactListContentWrapper,
  EmptyContent,
  ImageContainer,
  MaxContactError,
  QuantityContainer,
  RecipientQuantityInputArea,
  ShareLink,
  ShareLinks,
  TabDescriptionText,
  TabWrapper
};
